<template>
  <div>
    <div class="uk-form-controls uk-flex uk-flex-wrap">
      <form-radios :values="values" :name="name" :label="label" :slug="name" :id="id" :validations="validations"
        :required="required"></form-radios>
    </div>
    <a href="#" class="uk-link-text" v-if="openModal" :title="privacyLabel">{{ privacyLabel }}</a>
    <div class="gdpr-privacy-agreement__dropdown" v-if="openModal" uk-dropdown="mode: click">
      <div v-if="privacyLegalText === ''">
        <strong>{{ privacyLabel }}:</strong>
        <div v-html="privacyContent"></div>
      </div>
      <div v-else v-html="privacyLegalText"></div>
    </div>
    <div class="uk-position-relative" v-if="!openModal" uk-lightbox>
      <a :href="privacyLegalText === '' ? privacyUrl : privacyLegalUrl" class="uk-link-text" type="iframe"
        :title="privacyLabel">{{ privacyLabel }}</a>
    </div>
  </div>
</template>

<style lang="less">
@import (reference) "~less/app";

.gdpr-privacy-agreement {
  .uk-form-label {
    display: none;
  }

  [uk-dropdown] {
    p {
      margin-bottom: 0;
    }

    @media (min-width: @breakpoint-medium) {
      max-width: none;
    }
  }
}
</style>

<script>
export default {
  props: {
    id: {
      type: String,
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
    },
    required: {
      type: Boolean,
      default: true,
    },
    validations: {
      type: Array,
      default: () => ['required'],
    },
    consentString: {
      type: String,
    },
    values: {
      type: [Object, Map],
      default: () =>
        new Map([
          [1, window.App.i18n.t('rubinred.forms.privacies.common.privacy_labels.consent')],
          [0, window.App.i18n.t('rubinred.forms.privacies.common.privacy_labels.do_not_consent')],
        ]),
    },
    openModal: Boolean,
    privacyContent: String,
    privacyLabel: String,
    policyId: String,
    privacyLegalText: String,
    privacyLegalUrl: String,
    privacyUrl: String,
  },
}
</script>


// WEBPACK FOOTER //
// public/themes/frontend/mtg/extensions/rubinred/forms/assets/js/components/FormGdpr.vue